// Demo TCS Financial Data
import { CompanyFinancialData } from '../model/CompanyData';

export const tcsFinancialData: CompanyFinancialData = {
  stockInfo: {
    companyName: 'Tata Consultancy Services Ltd',
    symbol: 'TCS',
    bseCode: '532540',
    nseCode: 'TCS',
    currentPrice: 3192,
    priceChange: 3.5,
    priceChangePercent: 0.11,
    lastUpdated: '2024-12-11 16:01:00',
    weekHigh52: 4495,
    weekLow52: 2867,
    faceValue: 1,
    marketCap: 1155129
  },

  valuationRatios: {
    peRatio: 23.0,
    pbRatio: 10.8,
    bookValue: 294,
    evEbitda: 15.2,
    dividendYield: 1.88,
    priceToSales: 5.2
  },

  profitabilityMetrics: {
    roe: 52.4,
    roe3Year: 50.3,
    roe5Year: 48.9,
    roce: 64.6,
    operatingMargin: 27.0,
    netProfitMargin: 19.5,
    assetTurnover: 1.8
  },

  growthMetrics: {
    salesGrowth3Y: 12.5,
    salesGrowth5Y: 10.0,
    salesGrowth10Y: 14.2,
    profitGrowth3Y: 9.8,
    profitGrowth5Y: 8.0,
    profitGrowth10Y: 12.5,
    stockPriceCagr3Y: 5.2,
    stockPriceCagr5Y: 3.0,
    epsGrowth: 8.5
  },

  quarterlyResults: [
    {
      quarter: 'Q2 FY25',
      revenue: 64988,
      operatingProfit: 17545,
      netProfit: 12380,
      eps: 34.2,
      yoyGrowth: 8.2,
      qoqGrowth: 2.1
    },
    {
      quarter: 'Q1 FY25',
      revenue: 63689,
      operatingProfit: 17125,
      netProfit: 12040,
      eps: 33.3,
      yoyGrowth: 7.5,
      qoqGrowth: 1.8
    },
    {
      quarter: 'Q4 FY24',
      revenue: 61237,
      operatingProfit: 16540,
      netProfit: 11695,
      eps: 32.1,
      yoyGrowth: 6.8,
      qoqGrowth: 3.2
    },
    {
      quarter: 'Q3 FY24',
      revenue: 59381,
      operatingProfit: 15890,
      netProfit: 11342,
      eps: 31.0,
      yoyGrowth: 5.9,
      qoqGrowth: 2.5
    }
  ],

  annualResults: [
    {
      fiscalYear: 'FY24',
      revenue: 242047,
      operatingExpenses: 176832,
      ebitda: 65215,
      depreciation: 6234,
      interest: 412,
      profitBeforeTax: 58569,
      tax: 12145,
      netProfit: 46424,
      eps: 127.5
    },
    {
      fiscalYear: 'FY23',
      revenue: 225458,
      operatingExpenses: 164235,
      ebitda: 61223,
      depreciation: 5876,
      interest: 389,
      profitBeforeTax: 54958,
      tax: 11389,
      netProfit: 43569,
      eps: 119.3
    },
    {
      fiscalYear: 'FY22',
      revenue: 204252,
      operatingExpenses: 148967,
      ebitda: 55285,
      depreciation: 5234,
      interest: 356,
      profitBeforeTax: 49695,
      tax: 10298,
      netProfit: 39397,
      eps: 107.8
    }
  ],

  balanceSheet: [
    {
      fiscalYear: 'FY24',
      totalAssets: 158649,
      totalLiabilities: 158649,
      equity: 3621,
      reserves: 94394,
      borrowings: 9392,
      workingCapital: 45234,
      totalDebt: 9392,
      cash: 38456,
      inventories: 1245,
      receivables: 28934,
      fixedAssets: 32567
    },
    {
      fiscalYear: 'FY23',
      totalAssets: 145234,
      totalLiabilities: 145234,
      equity: 3621,
      reserves: 86234,
      borrowings: 8756,
      workingCapital: 41234,
      totalDebt: 8756,
      cash: 34567,
      inventories: 1123,
      receivables: 26345,
      fixedAssets: 30124
    }
  ],

  cashFlow: [
    {
      fiscalYear: 'FY24',
      operatingCashFlow: 48908,
      investingCashFlow: -12345,
      financingCashFlow: -28567,
      freeCashFlow: 36563,
      netCashFlow: 7996
    },
    {
      fiscalYear: 'FY23',
      operatingCashFlow: 45234,
      investingCashFlow: -10234,
      financingCashFlow: -26789,
      freeCashFlow: 35000,
      netCashFlow: 8211
    }
  ],

  shareholdingPattern: [
    {
      date: 'Sep 2024',
      promoterHolding: 71.77,
      fiiHolding: 10.33,
      diiHolding: 12.64,
      publicHolding: 5.21,
      promoterChange: 0.0
    },
    {
      date: 'Jun 2024',
      promoterHolding: 71.77,
      fiiHolding: 10.45,
      diiHolding: 12.52,
      publicHolding: 5.26,
      promoterChange: 0.0
    },
    {
      date: 'Mar 2024',
      promoterHolding: 71.77,
      fiiHolding: 10.52,
      diiHolding: 12.43,
      publicHolding: 5.28,
      promoterChange: 0.0
    }
  ],

  revenueSegments: [
    {
      segmentName: 'Banking & Financial Services',
      contribution: 32.6,
      quarter: 'Q2 FY25'
    },
    {
      segmentName: 'Consumer Business',
      contribution: 15.9,
      quarter: 'Q2 FY25'
    },
    {
      segmentName: 'Life Sciences & Healthcare',
      contribution: 10.9,
      quarter: 'Q2 FY25'
    },
    {
      segmentName: 'Technology & Services',
      contribution: 14.8,
      quarter: 'Q2 FY25'
    },
    {
      segmentName: 'Manufacturing',
      contribution: 12.3,
      quarter: 'Q2 FY25'
    },
    {
      segmentName: 'Others',
      contribution: 13.5,
      quarter: 'Q2 FY25'
    }
  ],

  corporateActions: [
    {
      type: 'acquisition',
      description: 'Acquisition of Coastal Cloud for up to USD 700 million',
      amount: 700,
      date: '2024-11-15',
      exDate: '2026-01-31'
    },
    {
      type: 'dividend',
      description: 'Final Dividend',
      amount: 27,
      date: '2024-07-12',
      exDate: '2024-07-12',
      recordDate: '2024-07-13'
    },
    {
      type: 'dividend',
      description: 'Interim Dividend',
      amount: 10,
      date: '2024-01-19',
      exDate: '2024-01-19',
      recordDate: '2024-01-22'
    }
  ]
};
